import { useEffect } from "react";
import i18n from "../../i18n";

/**
 * Watches a language value and applies it to i18n when it changes.
 * Decouples language switching from data-fetching concerns in TherapistProvider.
 */
export function useLanguageSync(language: string | null) {
    useEffect(() => {
        if (language) {
            i18n.changeLanguage(language);
        }
    }, [language]);
}
